const PROFILE_SIGNATURE_KEY = "agreement_profile_signature";

export function getStoredProfileSignature() {
  try {
    return localStorage.getItem(PROFILE_SIGNATURE_KEY) || null;
  } catch {
    return null;
  }
}

export function storeProfileSignature(signature) {
  try {
    if (signature && signature.trim() !== "") {
      localStorage.setItem(PROFILE_SIGNATURE_KEY, signature);
    } else {
      localStorage.removeItem(PROFILE_SIGNATURE_KEY);
    }
  } catch {
    // localStorage may be unavailable in private or restricted contexts.
  }
}

export function getProfileSignature(profile) {
  return profile?.signature || profile?.gsignature || "";
}
